import React from "react";
import './style.scss';
import bookingCofirm from "@assets/images/logo/booking_confirmation_logo.png";
import { formatDateCheckInOut, RootState } from "@share/utils";
import { DATE_FORMAT_DAY_MONTH } from "@constants";
import { enUS } from 'date-fns/esm/locale';
import { FormattedMessage, useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { get } from "lodash";
const DashboardHotelConfirm: React.FC<any> = ({
  orderResponse,
  searchHotels,
  guests,
  onVoucher
}) => {
  const locale = enUS;

  const policyLines = searchHotels?.cancellationPolicyText.split('\n').filter((line: string) => line.trim() !== '');

  const intl = useIntl();

  const { bookingComplete, booking } = useSelector((state: RootState) => state.reviewBookStore);
  const { account, userWallet, userWalletData } = useSelector((state: RootState) => state.loginStore);

  const isBookingComplete = !!bookingComplete;
  const bookingClientCash = isBookingComplete && booking ? get(booking?.hotelSegments, '[0].clientCash', 0) : 0;

  const isExternalWallet = account?.walletIsExternal;
  const hasClientCash = account?.hasClientCash;

  const isLogged = !!userWallet;

  const convertionRate = userWalletData?.convertionRate ? userWalletData?.convertionRate : 1;

  const usedClientCashAmount = bookingComplete && booking ? get(booking?.hotelSegments, '[0].clientCash', 0) : 0;
  const usedClientCashInt = Math.round(usedClientCashAmount / convertionRate);
  const usedClientCash = account?.walletNoDecimals
                                ? Math.floor(usedClientCashInt)
                                : usedClientCashInt;

  const isNonRefundable = isBookingComplete && !isExternalWallet && hasClientCash && isLogged && (bookingClientCash > 0 || usedClientCash > 0);
  const refundability = isNonRefundable ? 'nonrefundable' : searchHotels?.bookingCard?.package?.refundability;

  return (
    <div>
      <div className="row">
        <div>
          <div className="bookingConfirmation card shadow rounded-0">
          <div className="bookingConfirmation_box d-flex align-items-center jusitfy-content-center gap-3 flex-wrap flex-md-nowrap">
            <img src={bookingCofirm} alt="Hotel" className="img-fluid" />
            <div className="bookingConfirmation_box_txt">
              <span>{`${intl.formatMessage({ id: 'thank.you' })}, ${guests[0]?.givenName ? guests[0]?.givenName : ''}!`}</span>
                <h1><FormattedMessage id="booking.confirmation" values={{hotel : searchHotels?.bookingCard?.name}} /></h1>
                <p> <FormattedMessage id="email.has.been.sent" /> <a href={`mailto:${guests[0]?.email}`}>{ guests[0]?.email}</a></p>
            </div>
          </div>
          <p className="f-14 mb-3 mb-xl-4 text-dark"><strong>{searchHotels?.bookingCard?.name}</strong><FormattedMessage id="is.expecting.you.on" />: <strong className="ms-1">{formatDateCheckInOut(
                              searchHotels?.bookingCard?.checkIn,
                              DATE_FORMAT_DAY_MONTH,
                              locale,
                            )}</strong></p>
          <div className="bookingConfirmation_number mb-3 mb-xl-4">
            <p  className="f-16 text-dark mb-1"><FormattedMessage id="confirmation.number" />: {orderResponse?.hotelSegments[0].bookingId}</p>
            <ul className="list-unstyled mb-0">
              <li className="f-14 d-inline-flex">
                <i className="bi bi-info-circle me-2"></i>
                <FormattedMessage id="booking.info.reception" />
              </li>
              <li className="f-14 d-inline-flex">
                <i className="bi bi-info-circle me-2"></i>
                <FormattedMessage id="booking.info.concierge" />
              </li>
              <li className="f-14 d-inline-flex textdark">
                <i className="bi bi-info-circle me-2"></i>
                <strong>
                  <FormattedMessage id="booking.info.namePolicy" />
                </strong>
              </li>
            </ul>
          </div>
            {/* <p className="f-16 text-dark mb-3 mb-xl-4">Member ID: <strong>{guests[0]?.id}</strong> </p> */}
          <div className="bookingConfirmation_cancel mb-3 mb-xl-4">
              <p className="f-16 text-dark mb-2">
                <b><FormattedMessage id="cancellation.policy" />:</b>
                <span className={`${refundability === "nonrefundable" ? "text-danger" : "text-success"} ms-3 fw-bold`}>{refundability === 'nonrefundable' ? (intl.formatMessage({ id: 'non.refundable' })) : (intl.formatMessage({ id: 'refundable' }))} <i className="bi bi-info-circle-fill ms-1"></i></span>
              </p>
              
              {policyLines.map((line:string, index:number) => (
                <p key={index} className="f-14 mb-0 text-dark fw-light">
                  {line}
                </p>
              ))}
          </div>
            <p className="f-16 mb-3 mb-xl-4 text-dark"><strong><FormattedMessage id="booking.remarks" />: </strong>{searchHotels?.providerMessage} </p>
          {/* <p className="f-16 text-dark mb-0 fw-normal">Mandatory Fees:</p>
          <p className="f-14 mb-0 fw-light">You'll be asked to pay the following charges at the property:</p>
          <ul className="mb-3 text-dark">
            <li className="f-14">Resort fee: USD 70.00 per accommodation, per night</li>
          </ul>
          <p className="f-16 text-dark mb-0 fw-normal">The resort fee includes:</p>
          <ul className="mb-0 text-dark">
            <li className="f-14">Additional inclusions</li>
          </ul>
          <div className="my-2 moreBtn text-end">
            <button type="button">Show More</button>
          </div> */}
          <p className="mb-3 f-16 text-dark"><strong><FormattedMessage id="contact.property" />: </strong> 1-305-993-3300</p>
          <p className="mb-3 f-16 text-dark"><strong><FormattedMessage id="support" />:</strong> (828) 785-4573</p>
          <p className="mb-3 f-16 text-dark"><strong><FormattedMessage id="confirmation.resend.email" /></strong> <span onClick={onVoucher} className="resendBtn text-decoration-underline"><FormattedMessage id="confirmation.resend.email.resend" /></span> </p>
        </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardHotelConfirm;
